import { Box, Typography } from "@mui/material";
import theme from "../../../../theme";

export const GeneralInsights = ({ insights }) => (
  <Box
    sx={{
      display: "grid",
      gridTemplateColumns: { xs: "1fr", md: "1fr 1fr" },
      gap: 4,
      my: 5,
    }}
  >
    <Box>
      <Typography
        variant="h6"
        gutterBottom
        sx={{ color: theme.palette.primary.brandSecondary }}
      >
        General L3 Insights
      </Typography>

      <Typography variant="body2">
        {insights?.general?.["General L3 Details"] ??
          "No general l3 insights available."}
      </Typography>
    </Box>

    <Box>
      <Typography
        variant="h6"
        gutterBottom
        sx={{ color: theme.palette.primary.brandSecondary }}
      >
        Strategy & Savings
      </Typography>

      <Typography variant="body2">
        {insights?.strategy_and_savings?.["Savings Details"] ??
          "No strategy and savings insights available."}
      </Typography>

      <Typography variant="body2" sx={{ mt: 2, fontWeight: 600 }}>
        Largest Procurement Lever:{" "}
        {insights?.strategy_and_savings?.["Largest Procurement Lever(s)"] ??
          "-"}
      </Typography>
    </Box>
  </Box>
);
